import React from 'react';
import { Page } from '../Page';
import { CheckCircle2Icon, AlertTriangleIcon, ShieldCheckIcon } from 'lucide-react';
export function Page6() {
  const deficiencies = [{
    title: 'Fatigue',
    items: 'Folate (B9), B12, Vitamin D, Iron'
  }, {
    title: 'Hair Loss',
    items: 'Biotin (B7), Iron, Zinc'
  }, {
    title: 'Depression',
    items: 'B6, Folate (B9), Vitamin D, Iron'
  }, {
    title: 'Poor Sleep',
    items: 'Vitamin D, Iron, Magnesium'
  }];
  const vitamins = ['Vitamin A', 'Vitamin C', 'Vitamin D', 'Vitamin E', 'Vitamin K', 'Vitamin B1', 'Vitamin B2', 'Vitamin B3', 'Vitamin B5', 'Vitamin B6', 'Vitamin B7', 'Vitamin B9', 'Vitamin B12', 'Iron', 'Zinc'];
  return <Page pageNumber={12} variant="light" data-id="element-999" data-mp="1xf2osv1u6tnt">
      <div className="flex flex-col h-full" data-id="element-1000" data-mp="1xgvykj7qxu01">
        <div className="h-[160px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-1001" data-mp="1snko883q6v3d">
          <img src="https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=1000&q=80" alt="Vitamins and supplements" className="w-full h-full object-cover object-center" data-id="element-1002" data-mp="217dpm1d4mpkt" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-1003" data-mp="1ridks1by0zyp" />
        </div>

        <div className="mb-8" data-id="element-1004" data-mp="1wf40gnju5tjl">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1005" data-mp="1wec3b8albnr7">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1006" data-mp="1mir8bu3xvnqy">
            Vitamins <span className="text-tealslate" data-id="element-1007" data-mp="18j9doy3ypg9o">&</span> Minerals
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1008" data-mp="18l2jkb6r3wgm" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-1009" data-mp="1dicichg15kh4">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1010" data-mp="32w7nzhpnwcx0">
            People on GLP-1 medications eat much less due to reduced appetite.
            This makes it difficult to meet vitamin and mineral needs through
            food alone. A daily multivitamin acts as nutritional insurance.
          </p>
          <div data-id="element-1011" data-mp="31fbyjp71ilji">
            <h3 className="text-sm font-bold text-[#1F1F1F] mb-3 flex items-center gap-2" data-id="element-1012" data-mp="31eshsbt4m372">
              <AlertTriangleIcon className="w-4 h-4 text-[#C4956A]" data-id="element-1013" data-mp="2whjwi2colj1l" />
              Potential Deficiencies
            </h3>
            <div className="grid grid-cols-2 gap-2" data-id="element-1014" data-mp="2rj8nftu7nckf">
              {deficiencies.map((def, idx) => <div key={idx} className="bg-tealslate/10 p-2.5 border border-tealslate/20" data-id="element-1015" data-mp="3p4d0ctldayft" data-mpi={idx}>
                  <span className="font-bold text-[#1F1F1F] text-xs" data-id="element-1016" data-mp="3fetgplptz0jw">
                    {def.title}
                  </span>
                  <p className="text-[10px] text-[#7A7A70] mt-0.5" data-id="element-1017" data-mp="3afgvt6iis3jy">
                    {def.items}
                  </p>
                </div>)}
            </div>
          </div>
        </div>

        <h2 className="text-lg font-serif text-[#1F1F1F] mb-3" data-id="element-1018" data-mp="6yrp9kixstua">
          What Should Your Multivitamin Have?
        </h2>
        <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 mb-6" data-id="element-1019" data-mp="ecsjxflkpzjf">
          <div className="grid grid-cols-3 gap-y-2" data-id="element-1020" data-mp="jakc8aq4rno5">
            {vitamins.map((v, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-1021" data-mp="o82mq5jsqay9" data-mpi={idx}>
                <CheckCircle2Icon className="w-3.5 h-3.5 text-tealslate shrink-0" data-id="element-1022" data-mp="t8hxcpcp14cj" />
                <span className="text-[#3B3B3B] text-xs" data-id="element-1023" data-mp="x9jxr9icjmg3">{v}</span>
              </div>)}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4" data-id="element-1024" data-mp="127v7lk8n5wyb">
          <div className="bg-white border border-[#D8D8D0] p-4" data-id="element-1025" data-mp="126k4lmn0st89">
            <h3 className="font-bold text-[#1F1F1F] text-sm mb-2" data-id="element-1026" data-mp="170odwcjrddci">
              Pick a Form You'll Take
            </h3>
            <div className="flex gap-2 mb-2" data-id="element-1027" data-mp="1bxohmgt4y40g">
              {['Tablet', 'Gummy', 'Liquid'].map((f, i) => <span key={i} className="bg-tealslate/15 text-tealslate px-3 py-1 text-[10px] font-bold" data-id="element-1028" data-mp="1gvgdflwwia9x" data-mpi={i}>
                  {f}
                </span>)}
            </div>
            <p className="text-[10px] text-[#7A7A70]" data-id="element-1029" data-mp="2dpg37oibfmr1">
              Consistency is more important than form. Gummy and liquid forms
              are less likely to contain iron.
            </p>
          </div>
          <div className="bg-tealslate/10 border border-tealslate/20 p-4 flex flex-col justify-center" data-id="element-1030" data-mp="2nehg35tkdo0s">
            <div className="flex items-center gap-2 mb-2" data-id="element-1031" data-mp="1zq6lgkegokky">
              <ShieldCheckIcon className="w-5 h-5 text-tealslate" data-id="element-1032" data-mp="1uq246s5qblto" />
              <h3 className="font-bold text-[#1F1F1F] text-sm" data-id="element-1033" data-mp="1urwpi7kwxfya">
                Third-Party Tested
              </h3>
            </div>
            <p className="text-[10px] text-[#3B3B3B]" data-id="element-1034" data-mp="23qqkxumic0a9">
              Choose supplements certified by USP or NSF for safety and quality.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}